<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t1">Readers love</span></p>
<p class="p1"><span class="t2">R</span><span class="t3">EMMY</span><span class="t2"> D</span><span class="t3">UCHENE</span></p>
<p class="p2"><span class="t4">Deliver Me</span></p>
<p class="p3">“This story is about forgiveness and trust and finally standing up for what you want.”</p>
<p class="p4">—Prism Book Alliance</p>
<p class="p2"><span class="t4">This is Love </span><span class="t6">(with Allison Cassatta)</span></p>
<p class="p3">“I enjoyed this straightforward erotic romance of two men finding their life partner and making a life together.”</p>
<p class="p5">—The Book Vixen</p>
<p class="p3">“This is a must read for us hopeless romantics! Two gorgeous alpha males falling in love and figuring out how to keep it together and keep it real.”</p>
<p class="p5">—MM Good Book Reviews</p>
<p class="p3">“<span class="t8">This is Love</span> is a sweet, low-angst book. It is a good story about two damaged men who find love with each other.”</p>
<p class="p6">—The Novel Approach</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?3a01e62e